import { render, staticRenderFns } from "./DisplayAmenity.vue?vue&type=template&id=4754b334&"
import script from "./DisplayAmenity.vue?vue&type=script&lang=js&"
export * from "./DisplayAmenity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports